// 10-07-2025
import { ADD_HOST_IDS, HOST_SELECTED, RESET_HOST } from "./actionTypes";

// user
export const hostSelected = (hostId) => {
  return {
    type: HOST_SELECTED,
    payload: hostId,
  };
};

export const addHostIds = (id) => {
  return {
    type: ADD_HOST_IDS,
    payload: id,
  };
};

export const resetHost = () => ({
  type: RESET_HOST,
});
